import { LenderApprovalStatus } from '@nemuru-eng/js-api-client';
import React from 'react';

import { StatusTagType } from '../../../../../../../../config/types';
import { StatusTag } from '../../../../../StatusTag/StatusTag';

export const getLoanApplicationStatusTagProps = (
  approvalStatus: LenderApprovalStatus,
): React.ComponentProps<typeof StatusTag> => {
  switch (approvalStatus) {
    case LenderApprovalStatus.YES:
      return {
        type: StatusTagType.SUCCESS,
        colorType: 'main',
        labelTextId: 'ANSWERED_YES',
      };
    case LenderApprovalStatus.NO:
      return {
        type: StatusTagType.ERROR,
        colorType: 'main',
        labelTextId: 'ANSWERED_NO',
      };
    default:
      return {
        type: StatusTagType.INFO,
        colorType: 'main',
        labelTextId: 'IN_STUDY',
      };
  }
};
